import compuedFun from '../../../computed/'
import { parseTime } from '@/utils/util'
const { showName } = compuedFun()

export const searchForm = {
  field_name: undefined, // 字段名称
  field_state: undefined, // 字段状态 1启用 2禁用
  data_type: 1 // 数据类型 1文章 2采访 3案例
}

export const columns = [
  {
    title: '序号',
    align: 'center',
    dataIndex: 'id',
    // customRender(text, record, index) {
    //   return index + 1
    // }
  },
  {
    title: '字段所属',
    dataIndex: 'data_type',
    align: 'center',
    customRender(text, record, index) {
      return showName('TEMPLATE_TYPE', Number(text))
    }
  },
  {
    title: '字段标识',
    dataIndex: 'field',
    align: 'center'
  },
  {
    title: '字段名称',
    dataIndex: 'field_name',
    align: 'center'
  },
  {
    title: '字段类型',
    dataIndex: 'field_type',
    align: 'center',
    customRender(text, record, index) {
      return showName('TEMPLATE_FIELDS_TYPE', text)
    }
  },
  {
    title: '分类',
    dataIndex: 'field_class',
    align: 'center',
    customRender(text, record, index) {
      return showName('FIELD_CLASS', Number(text))
    }
  },
  {
    title: '状态',
    dataIndex: 'field_state',
    align: 'center',
    customRender(text, record, index) {
      return showName('TEMPLATE_STATE', Number(text))
    }
  },
  {
    title: '编辑日期',
    dataIndex: 'updated_at',
    align: 'center',
    customRender(text, record) {
      return +record.field_class !== 1 ? parseTime(text) : null
    }
  },
  {
    title: '备注',
    dataIndex: 'field_remark',
    align: 'left',
    customRender(text, record) {
      const { data_type } = record
      if (+data_type === 3) {
        return getFieldRemark(record)
      }
      return text || '--'
    }
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
]

export const fieldTypeDescMapping = {
  "input": "单行文本的输入限制，最多不超过1000字",
  "textarea": "多行文本支持换行",
  "editor": "富文本支持设置字体样式、段落、排版布局，支持上传图片、附件等",
  "radio": "",
  "checkbox": "",
  "number": "支持正数、负数，最多允许保留2位小数",
  "datePicker": "日期格式如 2022-01-01",
  "upload": "单张图片支持jpg、jpeg、png、gif，单张图不超过5M"
}

const getFieldRemark = (record) => {
  try {
    const { data_type, field_type, field_value } = record
    if (['radio', 'checkbox', 'upload'].includes(field_type) && Array.isArray(field_value)) {
      if (field_type === 'upload') {
        return `${field_value?.[0]?.pic_num ?? 0}张`
      } else {
        return field_value.map(item => item.value).join('、')
      }
    }
    return '--'
  } catch (error) {
    return ''
  }
}
